module.exports = __webpack_public_path__ + "static/img/saleicon4.c0c03d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/saleicon4.png
// module id = U8/f
// module chunks = 2